﻿import { FunctionComponent } from "react";
import { Text } from "@chakra-ui/react";
import { CommonStepProps } from "./CommonStepProps";

export type CompleteStepBodyProps = CommonStepProps & {};
export const CompleteStepBody: FunctionComponent<CompleteStepBodyProps> = () => {
    return <Text>Completion Step </Text>;
};
